import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/StructuredData/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/TranslationProvider/index.tsx");
